import React, { useState, useRef, useEffect } from "react";
import { BsPen, BsTrash , BsMailbox, BsLink} from "react-icons/bs";
import { useConfirm } from '../components/ConfirmContext';
export default function UsersAction({ row, onEdit, onDelete, onSendUserData, onOpenLink }) {
  const [open, setOpen] = useState(false);
  const [openLink, setOpenLink] = useState(false);
  const [menuPos, setMenuPos] = useState({ x: 0, y: 0 });
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  // 🔒 Zamknij po kliknięciu poza (ale nie w menu)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        !buttonRef.current?.contains(e.target) &&
        !menuRef.current?.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 📍 Pozycjonowanie menu
  const handleToggleMenu = () => {
    if (!open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPos({ x: rect.right - 180, y: rect.top }); // 180 = szerokość menu
    }
    setOpen((prev) => !prev);
  };

  const { requestConfirm } = useConfirm();

  return (
    <>
      {/* Przycisk trzech kropek */}
      <button
        ref={buttonRef}
        onClick={handleToggleMenu}
        className="p-2 rounded hover:bg-gray-100 transition"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 text-gray-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 12h.01M12 12h.01M18 12h.01" />
        </svg>
      </button>

      {/* FIXED menu – nie rozszerza tabeli */}
      {open && (
        <div
        ref={menuRef}
          style={{
            position: "fixed",
            top: `${menuPos.y}px`,
            left: `${menuPos.x}px`,
            zIndex: 9999,
          }}
          className="
            bg-white border border-gray-200 rounded-lg shadow-lg w-44
            animate-fadeIn
          "
        >
          <ul className="py-1 text-gray-700">

             {onSendUserData && (
            <li>
             <button
             
                onClick={() => {
                  requestConfirm(
                    `Czy na pewno chcesz wysłać dane logowania do tego użytkownika?`,
                    () => {
                      onSendUserData(row);
                      setOpen(false);
                    }
                  );
                }}
                className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
              >
                <BsMailbox className="w-4 h-4" />
                <span>Wyślij dane konta</span>
              </button>
            </li>
            )}
          
            <li>
              <button
                onClick={() => {
                  onEdit(row);
                  setOpen(false);
                }}
                className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
              >
                <BsPen className="w-4 h-4" />
                <span>Edytuj</span>
              </button>
            </li>

              {onOpenLink && (
 <li>
              <button
                onClick={() => {
                
                  setOpen(false);
                 onOpenLink(row);
                }}
                className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
              >
                <BsLink className="w-4 h-4" />
                <span>Pokaż link połączenia</span>
              </button>
            </li>
            )}
            {onDelete && (
            <li>
              <button
              onClick={() => {
                requestConfirm(
                  `Czy na pewno chcesz usunąć tego użytkownika?`,
                  () => {
                    onDelete(row.id);
                    setOpen(false);
                  }
                );
              }}
                className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
              >
               
                    <BsTrash className="w-4 h-4" />
                
                <span>Usuń</span>
              </button>
            </li>
            )}
          </ul>
        </div>
      )}
    </>
  );
}
